import gql from 'graphql-tag';

export const getAdditionalResourceListTypes = gql`
  query getAdditionalResourceListTypes {
    getAdditionalResourceListTypes {
      id
      name
      enabled
      deletedAt
    }
  }
`;
